import { normalizeDegrees } from 'lib/math/angle'
import { isInsideRect } from 'lib/math/rect'

const ORDINALS = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw']

const getPosition = ({ angle, distance, rect, target }) => {
  const rectWidth = rect.width
  const rectHeight = rect.height
  const centerX = target.x
  const centerY = target.y
  const hypotenuse = Math.sqrt(
    Math.pow(rectWidth, 2) + Math.pow(rectHeight, 2)
  )
  const widthOffset = (rectWidth / 2) * Math.cos(angle * (Math.PI / 180))
  const heightOffset = (rectHeight / 2) * Math.sin(angle * (Math.PI / 180))
  const offset = Math.sqrt(
    Math.pow(widthOffset, 2) + Math.pow(heightOffset, 2)
  )
  const normalizedDistance = (distance + offset) / hypotenuse
  const radians = angle * (Math.PI / 180)
  const offsetX = normalizedDistance * Math.cos(radians)
  const offsetY = normalizedDistance * Math.sin(radians)
  const left = centerX + offsetX * hypotenuse - rectWidth / 2
  const top = centerY + offsetY * hypotenuse - rectHeight / 2

  return {
    x: left,
    y: top
  }
}

const computeTooltipPosition = ({
  angle,
  distance,
  rect,
  rectContainer,
  target
}) => {
  let offset = 0
  let isInRect = false
  let baseAngle = angle + 270

  let position = getPosition({ angle: baseAngle, distance, rect, target })
  let nextRect = { ...rect, ...position }

  isInRect = isInsideRect(rectContainer, nextRect)

  if (!isInRect) {
    // If we get a bad first angle, first thing to do is swing it
    // to the opposite direction which is likely the best outcome
    baseAngle += 180

    if (nextRect.x + nextRect.width > rectContainer.x + rectContainer.width) {
      while (!isInRect && offset >= -360) {
        offset -= 1

        position = getPosition({
          angle: baseAngle - offset,
          distance,
          rect,
          target
        })

        nextRect = { ...rect, ...position }
        isInRect = isInsideRect(rectContainer, nextRect)
      }
    } else {
      while (!isInRect && offset <= 360) {
        offset += 1

        position = getPosition({
          angle: baseAngle - offset,
          distance,
          rect,
          target
        })

        nextRect = { ...rect, ...position }
        isInRect = isInsideRect(rectContainer, nextRect)
      }
    }
  }

  const ordinalAngle = normalizeDegrees(baseAngle - 270 - offset)
  const ordinal = ORDINALS[Math.round(ordinalAngle / 45)] || 'n'

  return {
    x: Math.round(position.x),
    y: Math.round(position.y),
    ordinal
  }
}

export default computeTooltipPosition
